export default ({
    date,
    priority = 1,
    availability = 0
}) => {
    if (typeof date !== 'string') {
        throw new TypeError('date must be of type `string`');
    }

    return {
        date,
        priority,
        availability: parseInt(availability) || 0
    };
};